import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api, ApiError } from '../api/client.js';
import { useAuth } from '../auth/store.js';

export function LoginPage() {
  const { t } = useTranslation();
  const setSession = useAuth((s) => s.setSession);
  const [mode, setMode] = useState<'login' | 'register'>('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const res =
        mode === 'login'
          ? await api.login(email, password)
          : await api.register(email, password, displayName);
      setSession(res.user, res.accessToken, res.refreshToken);
    } catch (err) {
      setError(
        err instanceof ApiError
          ? `${mode === 'login' ? t('auth.loginFailed') : t('auth.registerFailed')} (${err.status})`
          : 'Network error',
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      <form onSubmit={submit} className="card" style={{ width: 360 }}>
        <h2>{t('app.title')}</h2>
        {error && <div className="error-banner">{error}</div>}
        {mode === 'register' && (
          <div style={{ marginBottom: 12 }}>
            <label>{t('auth.displayName')}</label>
            <input value={displayName} onChange={(e) => setDisplayName(e.target.value)} required />
          </div>
        )}
        <div style={{ marginBottom: 12 }}>
          <label>{t('auth.email')}</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>{t('auth.password')}</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={8}
          />
        </div>
        <button type="submit" disabled={busy} style={{ width: '100%' }}>
          {mode === 'login' ? t('auth.login') : t('auth.register')}
        </button>
        <div className="muted" style={{ marginTop: 12, textAlign: 'center' }}>
          {mode === 'login' ? (
            <>
              {t('auth.noAccount')}{' '}
              <a href="#" onClick={(e) => { e.preventDefault(); setMode('register'); }}>
                {t('auth.register')}
              </a>
            </>
          ) : (
            <>
              {t('auth.haveAccount')}{' '}
              <a href="#" onClick={(e) => { e.preventDefault(); setMode('login'); }}>
                {t('auth.login')}
              </a>
            </>
          )}
        </div>
      </form>
    </div>
  );
}
